module.exports = __webpack_public_path__ + "static/media/profile_default_avatar_small.19a4e429.svg";